import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import '../styles/stylesTramitesServicios.css'; 
import AdministrativosSection from '../componentes/AdministrativosSection.jsx';

const Tramites = () => {
  const { hash } = useLocation();
  
  useEffect(() => {
    if (hash) {
      const elem = document.querySelector(hash);
      if (elem) elem.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [hash]);

  return (
    <div className="tramites-page">
    
      {/* Sección Administrativa */}
      <section id="tramitesAdministrativos">
        <AdministrativosSection />
      </section>

      {/* Sección Servicios Públicos (Recolección) */}
      <section className="serviciosPublicos" id="serviciosPublicos">
        <div className="recoleccion-container">
          <h2 className="serviciosPublicos-title">Cronograma de Residuos</h2>
          <p className="subtitle">Ayudanos a mantener Progreso limpio respetando los días y tipos de bolsas.</p>
          
          {/* --- GRUPO 1: LAS 3 TARJETAS PRINCIPALES --- */}
          <div className="cards-recoleccion">
            {/* Card 1: Orgánicos */}
            <div className="card-residuo organico">
              <div className="icono">🍂</div>
              <h3>Lunes, Miércoles y Viernes</h3>
              {/* Contenedor para forzar una línea */}
              <div className="etiqueta-container">
                 <span className="etiqueta-bolsa clara">Bolsa Clara</span>
              </div>
              <hr />
              <p><strong>Orgánicos</strong></p>
              <ul className="lista-residuos">
                <li>Restos de comida</li>
                <li>Saquitos de té y yerba</li>
                <li>Servilletas sucias</li>
                <li>Papeles pequeños</li>
              </ul>
            </div>

            {/* Card 2: Recuperables */}
            <div className="card-residuo reciclable">
              <div className="icono">♻️</div>
              <h3>Martes y Jueves</h3>
              <div className="etiqueta-container">
                  <span className="etiqueta-bolsa caja">Bolsas o Cajas</span>
              </div>
              <hr />
              <p><strong>Inorgánicos Recuperables</strong></p>
              <ul className="lista-residuos">
                <li>Vidrio, papel y cartón</li>
                <li>Plásticos y envases</li>
                <li>Latas y aerosoles</li>
                <li>Telas y trapos</li>
              </ul>
            </div>

            {/* Card 3: No Recuperables */}
            <div className="card-residuo negro">
              <div className="icono">🚫</div>
              <h3>Lunes, Miércoles y Viernes</h3>
              <div className="etiqueta-container">
                  <span className="etiqueta-bolsa negra">Bolsa Negra</span>
              </div>
              <hr />
              <p><strong>No Recuperables</strong></p>
              <ul className="lista-residuos">
                <li>Residuos de baño</li>
                <li>Cenizas y cigarrillos</li>
                <li>Excremento de mascotas</li>
                <li>Resto de basura</li>
              </ul>
            </div>
          </div>

          {/* --- TÍTULO INTERMEDIO --- */}
          <h3 className="titulo-seccion-especial">Residuos especiales:</h3>

          {/* --- GRUPO 2: LAS 4 TARJETAS DE ABAJO (FORMATO IGUALADO) --- */}
          {/* Usamos la misma clase contenedora para que herede el grid/flex */}
          <div className="cards-recoleccion info-adicional-wrapper">
            
            <div className="card-residuo especial">
                <div className="icono">🌿</div>
                <h4>Poda y Césped</h4>
                <hr />
                <p>Recolección diaria (según cuadras o manzanas).</p>
            </div>

            <div className="card-residuo especial">
                <div className="icono">🔩</div>
                <h4>Chatarra</h4>
                <hr />
                <p>Primer <strong>Jueves</strong> de cada mes.</p>
            </div>

            <div className="card-residuo especial">
                <div className="icono">🧱</div>
                <h4>Escombros</h4>
                <hr />
                <p>Ramas de gran volumen o escombros: <strong>Dar aviso previo.</strong></p>
            </div>

            <div className="card-residuo especial">
                <div className="icono">🛢️</div>
                <h4>Aceite Vegetal</h4>
                <hr />
                <p>En recipiente cerrado, en puntos de recolección o junto a recuperables.</p>
            </div>

          </div>

          <div className="contacto-reclamos">
            <p>📞 Consultas o reclamos: <strong>3497 402141</strong></p>
          </div>

        </div>
      </section>
      
      <Outlet />
    </div>
  )
}

export default Tramites;